import { enumParser } from '#validation/common/parsers';
import { AllPrivilege } from '../constants/member-privileges/types';
export const privilegeParser = enumParser(AllPrivilege);
